import { Text } from '@react-pdf/renderer'
import type { Style } from '@react-pdf/types'

export const PdfCircle = ({
  type,
  size = 14,
  color = '#000',
  style,
  prefix = '',
  suffix = ' ',
  unicode = '\uf111'
}: {
  type: 'FA-SLD' | 'FA-REG' | string[] | undefined
  size?: number
  color?: string
  style?: Style
  prefix?: string
  suffix?: string
  unicode?: string
}) => {
  return (
    <Text
      style={[
        {
          fontFamily: type,
          fontSize: size,
          fontWeight: 'bold',
          color: color,
          lineHeight: size / 10
        },
        style ?? {}
      ]}
    >
      {prefix}
      {unicode}
      {suffix}
    </Text>
  )
}
